export const MAX_ALLOWED_THUMBNAILS = 5
export const MAX_OPTIMIZED_SLIDE_IMG = 20

export const thumbnailImageSizes = {
  desktop: {
    size: '204px',
    srcWidth: 204,
  },
  tablet: {
    size: '157px',
    srcWidth: 157,
  },
  mobile: {
    size: '100vw',
    srcWidth: 767,
  },
}
